import { Effect, Layer } from "effect";
import { immutableModelDependencyFailure } from "./model.ts";
import { ImmutableModelIo } from "./service.ts";

const loadMonaco = Effect.tryPromise({ try: () => import("./monaco-live.ts"), catch: immutableModelDependencyFailure });

/** Lazy platform adapter: constructing a root does not load the browser editor. */
export const ImmutableModelIoLive = Layer.succeed(ImmutableModelIo, {
  acquire: Effect.fn("Frontend.ImmutableModelIo.lazyAcquire")(function* (request) {
    const module = yield* loadMonaco;
    return yield* module.immutableModelIo.acquire(request);
  }),
  validate: Effect.fn("Frontend.ImmutableModelIo.lazyValidate")(function* (entry) {
    const module = yield* loadMonaco;
    return yield* module.immutableModelIo.validate(entry);
  })
});
